import { render, staticRenderFns } from "./SourcesPage.vue?vue&type=template&id=19ada9a5"
import script from "./SourcesPage.vue?vue&type=script&lang=js"
export * from "./SourcesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports